import { useQuery } from 'react-query';
import moment from 'moment';
import { API_DATE_FORMAT } from '../../constants';
import * as api from '../../services/api';
import useAccount from './useAccount';

const useEmployeeApplications = ({
  employeeId,
  includeRejectedApplications = false,
  timeRange,
  includeHistory = false,
  onlyRejected = false
}) => {
  const { accountId } = useAccount();

  const from = timeRange?.start ? moment(timeRange.start).format(API_DATE_FORMAT) : undefined;
  const to = timeRange?.end ? moment(timeRange.end).format(API_DATE_FORMAT) : undefined;

  const storeKey = [
    'employeeApplications',
    accountId,
    employeeId,
    from,
    to,
    includeRejectedApplications,
    includeHistory,
    onlyRejected
  ];
  const { isLoading, data } = useQuery(
    storeKey,
    () =>
      api.fetchEmployeeApplications({
        accountId,
        employeeId,
        includeRejectedApplications,
        from,
        to,
        includeHistory,
        onlyRejected
      }),
    {
      staleTime: 0
    }
  );

  return {
    isLoading,
    applications: data?.data || []
  };
};

export default useEmployeeApplications;
